

import React, {  useState } from 'react';

import PaymentHistory from './PaymentHistory';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
    ADD_BANK,
    BANK_ACCOUNT,
    PAYMENTS
} from '../../../../constants/routes';
import Cards from './Cards'
import { useDispatch } from 'react-redux';

const RegisteredBank = ({ view, cardUser, bankInfo, deleteCard, isPaymentHistory }) => {

    const [deletePop, setDeletePop] = useState(false);
    const [changePop, setchangePop] = useState(false);
    const [cardPopup, setCardPopup] = useState(false);
    const { t, i18n } = useTranslation();
    const Popup = () => {
        return (
            <div className="card-popup-wrapper">
                <div className="card-popup">

                    {
                        deletePop ?
                            <div >
                                <h2>{t(`Delete card`)}</h2>
                                {
                                  <>
                                    <p className="delete-paid-card">{t('Are you sure that you want to ')}
                                    <span style={{ color: '#ff355a' }}>{t('delete this card')}</span>?
                                    {t('If you delete your credit card, all of your paid ')}
                                    <span style={{ color: '#36cfff' }}>{t(' subscription  ')}</span> 
                                    {t('plans will be  ')}<span style={{ color: '#ff355a' }}>{t('terminated')}</span>{t(' on their expiration dates.')}</p>

                                         <p>{t(`Are you sure?`)}</p>
                                         </>
                                }

                                <div className="popup-footer">


                                    <a onClick={() => { setCardPopup(false); setDeletePop(false) }} className="cancel-btn">{t(`Cancel`)}</a>
                                    <Link to={PAYMENTS} className="change-btn">{t(`Change card`)}</Link>

                                    <a onClick={() => { deleteCard(); setCardPopup(false); setDeletePop(false) }} className="change-btn">{t(`Delete`)}</a>
                                </div>
                            </div>
                            :
                            <div className="change-popup">
                                <h2>{t(`Change Bank`)}</h2>
                                <p>{t(`Are you sure?`)}</p>
                                <div className="popup-footer">

                                    <a onClick={() => { setCardPopup(false); setchangePop(false) }} className="cancel-btn">{t(`Cancel`)}</a>
                                    <Link to={ADD_BANK} className="change-btn">{t(`Change bank`)}</Link>
                                </div>
                            </div>
                    }
                </div>
            </div>

        )
    }
   

    return (
        <div className={'registered-container unregister-container m-3'} >
            {cardPopup && Popup()}
            {
         
                    <>

                        <div>
                            <div className="unregister-header"><h2>{t(`Your Bank`)}</h2></div>
                            <div className="card-container bank-container">
                                <div className="card-container--header d-flex">
                                    <div className="card-type d-flex">
                                      
                                        <div className='card--type'>

                                            {bankInfo.payoutInfo.map(item => item.bankName)}
                                        </div>
                                    </div>
                                
                                </div>
                                <div className="card-container--body">
                                    <div >{bankInfo.firstName}  {bankInfo.lastName}</div>
                                    <div>{bankInfo.payoutInfo.map(item => item.bankAccountId)}</div>

                                </div>
                                <div  className="card-container--footer d-flex">
                                    <a onClick={() => { setchangePop(true); setCardPopup(true) }}>{t(`Change bank`)}</a>
                                    {/* <a onClick={() => { setDeletePop(true); setCardPopup(true) }}>{t(`Delete`)}</a> */}
                                </div>
                            </div>
                      
                        </div>
                  
                   

                    </>
            }
        </div>
    );
};

export default RegisteredBank;

